import React from 'react';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';

import ChangeEmailForm from './ChangeEmailForm';

interface IModalProps {
    open: boolean,
    handleClose: () => void;
}

const ChangeEmailModal: React.FC<IModalProps> = ({open, handleClose}) => {

    return <MainModal
        header={t`Изменить E-mail`}
        open={open}
        handleClose={handleClose}
        size="md"
    >
        <ChangeEmailForm onClose={handleClose} />
    </MainModal>;
};

export default ChangeEmailModal;